var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Accordion, AccordionItem } from '../../../../molecules/Accordion';
import { MediaCopy } from '../..';
export const FrequentlyAskedQuestions = (_a) => {
    var { headline, headlineAsHTMLTag = 'h2', subheadline, entries, imageDesktop, imageMobile, layout = 'half-grid', scaling = 80 } = _a, rest = __rest(_a, ["headline", "headlineAsHTMLTag", "subheadline", "entries", "imageDesktop", "imageMobile", "layout", "scaling"]);
    return (React.createElement(MediaCopy, Object.assign({ headline: {
            variant: 'Headline1',
            asHTMLTag: headlineAsHTMLTag,
            children: headline,
        }, isContentCentered: false, text: { children: subheadline }, direction: "rtl", media: {
            positionX: 'center',
            positionY: 'end',
            scaling: scaling,
            mobile: {
                variant: 'image',
                alt: '',
                src: imageMobile,
            },
            desktop: {
                variant: 'image',
                alt: '',
                src: imageDesktop,
            },
        }, layout: layout }, rest),
        React.createElement(Accordion, null, entries.map(({ question, answer, trackingId }) => (React.createElement(AccordionItem, { key: question, title: question, "data-trackingid": trackingId, "data-testid": "faq-item" }, answer))))));
};
